<div *transloco="let t" [style]="altomateStyle">
  <div style="margin-bottom: 6px;" class="body-xs-semibold"> {{ t(title) }}</div>

  <div [style.border]="validator?.['error_message'] ? '1px solid #ff4d4f' : '1px solid #E4E0EB'"
    [style.background-color]="disabled === true ? '#f5f5f5' : ''"
    style="height: 48px; width: 100%; border-radius: 8px; display: flex; align-items: center; padding-right: 8px;">
    <p-dropdown [appendTo]="appendTo" [editable]="editable"  [virtualScroll]="true"    [virtualScrollItemSize]="38"  class="normalDropdown" [showClear]="showClear" [disabled]="disabled" (onChange)="onChange($event)"
      [options]="options" [filterFields]="filterFields" styleClass="altomate-selection"
      [panelStyle]="dropdownPanelStyle" [(ngModel)]="boundModel" [optionValue]="bindValue" [filter]="filter"
      filterMatchMode="contains" [placeholder]="t(placeholder)">
      <ng-template let-selectedItem class="body-sm-medium" pTemplate="selectedItem" let-selectedOption
        style="width: 100%; margin-right: 50px;">
        <div class="body-sm-medium row-center" style="gap: 10px; margin-right: 10px; justify-content: flex-start; ">
          <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
            [style.text-transform]="isCapitalRequired === true ? 'uppercase': ''" class="body-sm-medium"> {{ (bindLabel
            === '' ? t(selectedItem) : t(selectedItem[bindLabel]) ) }} </div>
        </div>
      </ng-template>


      <ng-template let-item pTemplate="item">
        <div class="body-sm-medium row-center" style="gap: 10px; justify-content: flex-start;">
          <div [style.text-transform]="isCapitalRequired === true ? 'uppercase': ''"
            style="word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">
            {{ bindLabel === '' ? t(item) : t(item[bindLabel]) }}
          </div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>


  <div *ngIf="showRemarks === true" class="remark-message"> {{ remark }} </div>
  <div class="error-message"> {{ validator?.['error_message'] === null ? '' : t(validator['error_message']) }} </div>

</div>


<ng-template style="background-color: transparent;" #closeIcon>

</ng-template>